import initialstate from '../../../../reducers/initialstate';
import utilityFunction from '../../../../util/utilityfunctions';

export default function oversightAllProjectsReducer(state = initialstate.oversightAllProjects, action) {
	switch (action.type) {
		case 'GET_OVERSIGHTPROJECTS_BY_ENGAGEMENT':
			if (action.response) {
				return utilityFunction.sortListData(action.response, 'name') || state;
			}
			return state;
		case 'GET_OVERSIGHTPROJECT_BY_PROJECTID':
			if (action.response) {
				let projects = state.map((p) => {
					if (p.projectId === action.response.projectId) {
						return {
							...p,
							projectDetail: action.response
						};
					} else {
						return p;
					}
				});

				return projects;
			}
			return state;
		default:
			return state;
	}
}
